<template>
		<v-row justify="center">
			<v-dialog v-model="$store.state.showQr" max-width="290">
				<v-card>
					<v-card-title class="headline">QR del Negocio</v-card-title>
					<v-card-text>
						<qr-code 
								:text="`https://menu-qr.web.app/i/${$store.state.valueQr}`"
								color="#C1272D"
								bg-color="#ECEFF1" 
								error-level="L">
						</qr-code>
						
						ID: {{ $store.state.valueQr }}
						
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="secondary" text @click="close">Cerrar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-row>
</template>
<script>
	export default {
		name: 'qrDialog',	
		methods: {
			close(){
				this.$store.commit('SETQR',{show_qr: false, value_qr: null}, {root: true});
			}
		}

	}
</script>
